<template>
  <div>
    <div class="row">
      <div class="col-md-12 d-flex align-items-center mt-2">
        <span v-if="operationLot.lotCoPro.value" class="section-title">{{
            $t('OperationLot')
          }} {{ operationLot.lotCoPro.value }} - {{ operationLot.name.value }}</span>
        <span v-else class="section-title">{{ $t('OperationLot') }} {{ lotNumber }} - {{
            operationLot.name.value
          }}</span>
        <trash-icon v-if="deletable" class="main-red-color trashIcon ml-2" size="16" @click="removeOperationLot"/>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12 mt-3 mb-3">
        <span class="bold-text">{{ $t('operation.General.infos') }}</span>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6 ">
        <b-form-group
          :invalid-feedback="operationLot.name.invalidFeedback"
          :label="$t('operationLot.Name')"
          :label-for="`name-input-${index}`"
          :state="operationLot.name.state"
          class="medium-label ">
          <b-form-input
            :id="`name-input-${index}`"
            v-model="operationLot.name.value"
            :state="operationLot.name.state"
            maxlength="250"
            required
            type="text"
            v-on:change="emitChangeValue(operationLot); removeInvalidFeedback('name');">
          </b-form-input>
        </b-form-group>
      </div>

      <div class="col-md-2 ">
        <b-form-group
          :invalid-feedback="operationLot.surface.invalidFeedback"
          :label="$t('operationLot.Surface')"
          :label-for="`surface-input-${index}`"
          :state="operationLot.surface.state"
          class="medium-label">
          <b-input-group>
            <b-form-input
              :id="`surface-input-${index}`"
              v-model="operationLot.surface.value"
              v-disable-scroll
              :state="operationLot.surface.state"
              min="0"
              required
              step="0.01"
              type="number"
              v-on:change="emitChangeValue(operationLot); removeInvalidFeedback('surface'); updateValues('surface');">
            </b-form-input>
            <b-input-group-append>m²</b-input-group-append>
          </b-input-group>
        </b-form-group>
      </div>

      <div class="col-md-2 ">
        <b-form-group
          :invalid-feedback="operationLot.prixParM2.invalidFeedback"
          :label="$t('operationLot.PrixParM2')"
          :label-for="`prixParM2-input-${index}`"
          :state="operationLot.prixParM2.state"
          class="medium-label">
          <b-input-group>
            <b-form-input
              :id="`prixParM2-input-${index}`"
              v-model="operationLot.prixParM2.value"
              v-disable-scroll
              :state="operationLot.prixParM2.state"
              min="0"
              required
              step="any"
              type="number"
              v-on:change="emitChangeValue(operationLot); removeInvalidFeedback('prixParM2'); updateValues('prixParM2');">
            </b-form-input>
            <b-input-group-append>€</b-input-group-append>
          </b-input-group>
        </b-form-group>
      </div>

      <div class="col-md-2 ">
        <b-form-group
          :invalid-feedback="operationLot.prixVenteTTC.invalidFeedback"
          :label="$t(`operationLot.PrixVenteTTC${isHT ?'.HT':''}`)"
          :label-for="`prixVenteTTC-input-${index}`"
          :state="operationLot.prixVenteTTC.state"
          class="medium-label ">
          <b-input-group>
            <b-form-input
              :id="`prixVenteTTC-input-${index}`"
              v-model="operationLot.prixVenteTTC.value"
              v-disable-scroll
              :state="operationLot.prixVenteTTC.state"
              class="bold-text"
              min="0"
              required
              step="any"
              type="number"
              v-on:change="emitChangeValue(operationLot); removeInvalidFeedback('prixVenteTTC'); updateValues('prixVenteTTC');">
            </b-form-input>
            <b-input-group-append>€</b-input-group-append>
          </b-input-group>
        </b-form-group>
      </div>

      <div class="col-md-3 ">
        <b-form-group
          :invalid-feedback="operationLot.lotCoPro.invalidFeedback"
          :label="$t('operationLot.LotCoPro')"
          :label-for="`lotCoPro-input-${index}`"
          :state="operationLot.lotCoPro.state"
          class="medium-label">
          <b-form-input
            :id="`lotCoPro-input-${index}`"
            v-model="operationLot.lotCoPro.value"
            :state="operationLot.lotCoPro.state"
            maxlength="250"
            type="text"
            v-on:change="emitChangeValue(operationLot); removeInvalidFeedback('lotCoPro');">
          </b-form-input>
        </b-form-group>
      </div>

      <div class="col-md-3 ">
        <b-form-group
          :invalid-feedback="operationLot.etage.invalidFeedback"
          :label="$t('operationLot.Etage')"
          :label-for="`etage-input-${index}`"
          :state="operationLot.etage.state"
          class="medium-label">
          <b-form-select
            :id="`etage-input-${index}`"
            v-model="operationLot.etage.value"
            :state="operationLot.etage.state"
            v-on:change="emitChangeValue(operationLot); removeInvalidFeedback('etage')">
            <option v-for="option in etages" :value="option.value">
              {{ $t(option.text) }}
            </option>
          </b-form-select>
        </b-form-group>
      </div>

      <div v-if="operationType ==='VIR'" class="col-md-3 ">
        <b-form-group
          :invalid-feedback="operationLot.isLotVir.invalidFeedback"
          :label="$t('operationLot.isLotVir')"
          :label-for="`isLotVir-input-${index}`"
          :state="operationLot.isLotVir.state"
          class="medium-label">
          <b-form-select
            :id="`isLotVir-input-${index}`"
            v-model="operationLot.isLotVir.value"
            :state="operationLot.isLotVir.state"
            v-on:change="emitChangeValue(operationLot); removeInvalidFeedback('isLotVir')">
            <option v-for="option in [{text:'Oui', value:true},{text:'Non', value:false}]" :value="option.value">
              {{ $t(option.text) }}
            </option>
          </b-form-select>
        </b-form-group>
      </div>

      <div class="col-md-3">
      </div>


      <div class="col-md-6 mb-3" >
        <b-form-group
          :invalid-feedback="operationLot.typeLot.invalidFeedback"
          :label="$t('operationLot.TypeLot')"
          :label-for="`typeLot-input-${index}`"
          :state="operationLot.typeLot.state"
          class="medium-label">
          <custom-tva-select
            v-if="typesLot.length"
            :id="`typeLot-input-${index}`"
            v-model="operationLot.typeLot.value"
            :is-h-t="isHT"
            :options="typesLot"
            :state="operationLot.typeLot.state"
            required
            @input="emitChangeValue(operationLot); removeInvalidFeedback('typeLot')">
          </custom-tva-select>
        </b-form-group>
      </div>

      <div class="col-md-6 mb-3">
        <b-form-group
          :label="$t('operationLot.TypeTVA')"
          class="medium-label"
          label-for="typeTVA">
          <div id="typeTVA">{{ typeTVA }}</div>
        </b-form-group>
      </div>
    </div>

    <!--   ZONE LOCATION  -->

    <div v-if="!isHT" class="row">
      <div class="col-md-12  mb-3">
        <span class="bold-text">{{ $t('operation.edit.vente.location') }}</span>
      </div>
    </div>

    <div v-if="!isHT" class="row">
      <div class="col-md-3">
        <b-form-group
          :label="$t('simulationLot.AcheteLoue')"
          class="medium-label mb-4"
          label-for="is-loue-input">
          <b-form-select
            id="is-loue-input"
            v-model="operationLot.isLoue.value"
            :options="[
              { value: true, text: $t('oui') },
              { value: false, text: $t('non') }
            ]"
            @change="handleIsLoueChange">
          </b-form-select>
        </b-form-group>
      </div>

      <div v-if="operationLot.isLoue.value" class="col-md-3">
        <b-form-group
          :invalid-feedback="operationLot.nomLocataire.invalidFeedback"
          :label="$t('simulationLot.NomLocataire')"
          :label-for="`nom-locataire-${index}`"
          :state="operationLot.nomLocataire.state"
          class="medium-label">
          <b-form-input
            :id="`nomLocataire-input-${index}`"
            v-model="operationLot.nomLocataire.value"
            :state="operationLot.nomLocataire.state"
            maxlength="250"
            required
            type="text"
            @change="emitChangeValue; removeInvalidFeedback('nomLocataire')">
          </b-form-input>
        </b-form-group>
      </div>

      <div v-if="operationLot.isLoue.value" class="col-md-3">
        <b-form-group
          :label="$t('simulationLot.DateFinBail')"
          :label-for="`dateFinBail-input-${index}`"
          :state="operationLot.dateFinBail.state"
          class="medium-label">
          <datepicker-input
            v-model="operationLot.dateFinBail.value"
            :input-id="`dateFinBail-input-${index}`"
            :invalid-feedback="operationLot.dateFinBail.invalidFeedback"
            :state="operationLot.dateFinBail.state"
            required
            @change="removeInvalidFeedback('dateFinBail')"
            v-on:input="emitChangeValue(operationLot); removeInvalidFeedback('dateFinBail')"/>
        </b-form-group>
      </div>

      <div v-if="operationLot.isLoue.value" class="col-md-3">
        <b-form-group
          :label="$t('simulationLot.DateButoirResiliation')"
          :label-for="`date-butoir-resiliation-${index}`"
          :state="operationLot.dateButoirResiliation.state"
          class="medium-label">
          <datepicker-input
            v-model="operationLot.dateButoirResiliation.value"
            :input-id="`dateButoirResiliation-input-${index}`"
            :invalid-feedback="operationLot.dateButoirResiliation.invalidFeedback"
            :state="operationLot.dateButoirResiliation.state"
            required
            @change="removeInvalidFeedback('dateButoirResiliation')"
            v-on:input="emitChangeValue(operationLot); removeInvalidFeedback('dateButoirResiliation')"/>
        </b-form-group>
      </div>

      <div v-if="operationLot.isLoue.value" class="col-md-3">
        <b-form-group
          :invalid-feedback="operationLot.loyersPercus.invalidFeedback"
          :label="$t('simulationLot.LoyersPercus')"
          :label-for="`loyers-percus-${index}`"
          :state="operationLot.loyersPercus.state"
          class="medium-label">
          <b-input-group>
            <b-form-input
              :id="`loyersPercus-input-${index}`"
              v-model="operationLot.loyersPercus.value"
              v-disable-scroll
              min="0"
              required
              step="0.01"
              type="number"
              @change="emitChangeValue(operationLot); removeInvalidFeedback('loyersPercus')">
            </b-form-input>
            <b-input-group-append>€</b-input-group-append>
          </b-input-group>
        </b-form-group>
      </div>

      <div v-if="operationLot.isLoue.value" class="col-md-3">
        <b-form-group
          :invalid-feedback="operationLot.tauxTVA.invalidFeedback"
          :label="$t('chargePro.Value.TVA')"
          :label-for="`taux-tva-${index}`"
          :state="operationLot.tauxTVA.state"
          class="medium-label">
          <b-input-group>
            <b-form-input
              :id="`tauxTVA-input-${index}`"
              v-model="operationLot.tauxTVA.value"
              v-disable-scroll
              max="100"
              min="0"
              required
              step="0.01"
              type="number"
              @change="emitChangeValue(operationLot); removeInvalidFeedback('tauxTVA')">
            </b-form-input>
            <b-input-group-append>%</b-input-group-append>
          </b-input-group>
        </b-form-group>
      </div>


    </div>


    <div class="row">
      <div class="col-md-12  mb-3">
        <span class="bold-text">{{ $t('OperationConstruction') }}</span>
      </div>
    </div>

    <div class="row">

      <div class="col-md-6 mb-3">
        <b-form-group
          :invalid-feedback="operationLot.debutConstruction.invalidFeedback"
          :label="$t('operationPlanning.operation.debut.construction.renovation')"
          :label-for="`debutConstruction-input-${index}`"
          :state="operationLot.debutConstruction.state"
          class="medium-label ">
          <datepicker-input
            :id="`debutConstruction-input-${index}`"
            v-model="operationLot.debutConstruction.value"
            :state="operationLot.debutConstruction.state"
            v-on:input="emitChangeValue(operationLot); removeInvalidFeedback('debutConstruction')"/>
        </b-form-group>
      </div>

      <div class="col-md-6 mb-3">
        <b-form-group
          :invalid-feedback="operationLot.finConstruction.invalidFeedback"
          :label="$t('operationPlanning.operation.fin.construction.renovation')"
          :label-for="`finConstruction-input-${index}`"
          :state="operationLot.finConstruction.state"
          class="medium-label ">
          <datepicker-input
            :id="`finConstruction-input-${index}`"
            v-model="operationLot.finConstruction.value"
            :state="operationLot.finConstruction.state"
            v-on:input="emitChangeValue(operationLot); removeInvalidFeedback('finConstruction')"/>
        </b-form-group>
      </div>

    </div>

    <div class="row">
      <div class="col-md-12  mb-3">
        <span class="bold-text">{{ $t('operation.edit.vente.date') }}</span>
      </div>
    </div>

    <div class="row">

      <div class="col-md-4">
        <div class="row justify-content-between px-3 pb-2 medium-text">
          <div>
            {{ $t('operationPlanning.operation.ssp.vente') }}
            <b-tooltip html target="info-circle-ssp-vente" variant="dark">
              {{ $t('operation.sspSaleDate.info') }}
            </b-tooltip>
            <b-icon id="info-circle-ssp-vente" class="ml-2" icon="info-circle" variant="primary"></b-icon>
          </div>
          <div class="row px-2">
            <span class="mr-2"> {{ $t('evenementPlanning.date.reelle') }} </span>
            <b-form-checkbox v-model="operationLot.realDateSSP.value" @change="handleSSPVenteChange"></b-form-checkbox>
          </div>
        </div>
        <datepicker-input
          :id="`sspVente-input-${index}`"
          v-model="operationLot.sspVente.value"
          :state="operationLot.sspVente.state"
          v-on:input="emitChangeValue(operationLot); removeInvalidFeedback('sspVente')"/>
      </div>


      <div class="col-md-4 mb-3">
        <div class="row justify-content-between px-3 pb-2 medium-text">
          <div>
            {{ $t('operationPlanning.operation.acte.vente') }}
            <b-tooltip html target="info-circle-acte-vente" variant="dark">
              {{ $t('operation.saleActDate.info') }}
            </b-tooltip>
            <b-icon id="info-circle-acte-vente" class="ml-2" icon="info-circle" variant="primary"></b-icon>
          </div>
          <div class="row px-2">
          <span :style="{ color: isActeVenteDisabled() ? '#8c8c8c' : '#000' }" class="mr-2"> {{
              $t('evenementPlanning.date.reelle')
            }} </span>
            <b-form-checkbox v-model="operationLot.realDate.value" :disabled="isActeVenteDisabled()"></b-form-checkbox>
          </div>
        </div>
        <datepicker-input
          :id="`acteVente-input-${index}`"
          v-model="operationLot.acteVente.value"
          :state="operationLot.acteVente.state"
          v-on:input="emitChangeValue(operationLot); removeInvalidFeedback('acteVente')">
        </datepicker-input>
      </div>

      <div class="col-md-4 mb-3">
        <div class="row justify-content-between px-3 pb-2 medium-text">
          <div>
            {{ $t('operationPlanning.operation.lot.percentage.treso') }}
            <b-tooltip html target="info-circle-percentage-vente" variant="dark">
              {{ $t('operationPlanning.operation.lot.percentage.treso.info') }}
            </b-tooltip>
            <b-icon id="info-circle-percentage-vente" class="ml-2" icon="info-circle" variant="primary"></b-icon>
          </div>
        </div>
        <b-input-group>
          <b-form-input
            :id="`percentageTreso-input-${index}`"
            v-model="operationLot.percentageTreso.value"
            v-disable-scroll
            :disabled="operationLot.isLotVir.value || operationType === 'VEFA'"
            :state="operationLot.percentageTreso.state"
            max="100"
            min="0"
            step="1"
            type="number"
            v-on:change="emitChangeValue(operationLot); removeInvalidFeedback('percentageTreso');">
          </b-form-input>
          <b-input-group-append>%</b-input-group-append>
        </b-input-group>
      </div>

      <div class="col-md-4 mb-3">
        <div class="row justify-content-between px-3 pb-2 medium-text">
          <div>
            {{ $t('operationPlanning.operation.lot.date.butoir.pret.acheteur') }}
            <b-tooltip html target="info-circle-pret-acheteur-vente" variant="dark">
              {{ $t('operationPlanning.operation.lot.date.butoir.pret.acheteur.info') }}
            </b-tooltip>
            <b-icon id="info-circle-pret-acheteur-vente" class="ml-2" icon="info-circle" variant="primary"></b-icon>
          </div>
        </div>
        <datepicker-input
          :id="`pretAcheteur-input-${index}`"
          v-model="operationLot.pretAcheteur.value"
          :state="operationLot.pretAcheteur.state"
          v-on:input="emitChangeValue(operationLot); removeInvalidFeedback('pretAcheteur')">
        </datepicker-input>
      </div>


      <div class="col-md-4 mb-3">
        <div class="row justify-content-between px-3 pb-2 medium-text">
          <div>
            {{ $t('operationPlanning.operation.lot.date.butoir.depot.permis') }}
            <b-tooltip html target="info-circle-depot-permis-vente" variant="dark">
              {{ $t('operationPlanning.operation.lot.date.butoir.depot.permis.info') }}
            </b-tooltip>
            <b-icon id="info-circle-depot-permis-vente" class="ml-2" icon="info-circle" variant="primary"></b-icon>
          </div>
        </div>
        <datepicker-input
          :id="`depotPermis-input-${index}`"
          v-model="operationLot.depotPermis.value"
          :state="operationLot.depotPermis.state"
          v-on:input="emitChangeValue(operationLot); removeInvalidFeedback('depotPermis')">
        </datepicker-input>
      </div>

      <div class="col-md-4 mb-3">
        <div class="row justify-content-between px-3 pb-2 medium-text">
          <div>
            {{ $t('operationPlanning.operation.lot.date.butoir.accord.permis') }}
            <b-tooltip html target="info-circle-accord-permis-vente" variant="dark">
              {{ $t('operationPlanning.operation.lot.date.butoir.accord.permis.info') }}
            </b-tooltip>
            <b-icon id="info-circle-accord-permis-vente" class="ml-2" icon="info-circle" variant="primary"></b-icon>
          </div>
        </div>
        <datepicker-input
          :id="`accordPermis-input-${index}`"
          v-model="operationLot.accordPermis.value"
          :state="operationLot.accordPermis.state"
          v-on:input="emitChangeValue(operationLot); removeInvalidFeedback('accordPermis')">
        </datepicker-input>
      </div>

    </div>


    <div class="row">
      <div class="col-md-12 mt-3 mb-3">
        <span class="bold-text">{{ $t('operation.General.other.infos') }}</span>
      </div>
    </div>


    <div class="row">

      <div class="col-md-12">
        <b-form-group
          class="medium-label mb-3">
          <div class="d-flex">
            <label :for="`comment-input-${index}`">
              {{ $t('operationLot.Comment') }}
            </label>
            <span class="ml-1">{{ $t('facultative.for.label') }}</span>
          </div>
          <b-form-textarea
            :id="`comment-input-${index}`"
            v-model="operationLot.comment.value"
            maxlength="1000"
            type="text"
            v-on:change="emitChangeValue(operationLot); removeInvalidFeedback('comment')">
          </b-form-textarea>
        </b-form-group>
      </div>
    </div>

    <div
      v-if="needSchedule && operationType && ((operationType ==='VIR' && operationLot.isLotVir.value) || (operationType ==='VEFA'))"
      class="row">
      <div class="col no-gutters mx-0 my-0">
        <schedule-vir-vefa :amount-vente="operationLot.prixVenteTTC.value"
                           :initial-schedule="this.operationLot.schedule && this.operationLot.schedule.value ? this.operationLot.schedule.value : templateSchedule"
                           :need-amount-preview="true"
                           @schedule-changed="scheduleChanged"></schedule-vir-vefa>

      </div>
    </div>
  </div>

</template>
<script>
import CustomTvaSelect from "../../../components/CustomTvaSelect";
import DatepickerInput from '../../../components/b122/editFields/DatepickerInput';
import ScheduleVirVefa from "./ScheduleVirVefa";

export default {

  name: "OperationLotComponent",

  components: {
    CustomTvaSelect,
    DatepickerInput,
    ScheduleVirVefa
  },

  props: {
    operationLot: {
      type: Object,
      default: null
    },
    lotNumber: {
      type: Number,
      default: 1
    },
    deletable: {
      type: Boolean,
      default: true
    },
    typesLot: {
      type: Array,
      default() {
        return []
      }
    },
    etages: {
      type: Array,
      default() {
        return []
      }
    },
    TVATypes: {
      type: Array,
      default() {
        return []
      }
    },
    index: {
      type: Number,
      default: 0
    },
    operationType: {
      type: String,
      default: null
    },
    needSchedule: {
      type: Boolean,
      default: false
    },
    templateSchedule: {
      type: Object,
      default: null
    },
    isHT: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {}
  },

  watch: {
    operationType: {
      handler() {
        if (this.operationType === 'VIR' || this.operationLot.isLotVir.value) {
          this.operationLot.percentageTreso.value = 0
        }
      },
      immediate: true,
      deep: true
    },
    'operationLot.isLotVir.value': {
      handler() {
        if (this.operationType === 'VIR' || this.operationLot.isLotVir.value) {
          this.operationLot.percentageTreso.value = 0
        }
      },
      immediate: true,
      deep: true
    },

    typesLot: {
      handler(newVal) {
        if (newVal.length && this.operationLot.typeLot.value) {
          this.$forceUpdate()
        }
      },
      deep: true,
      immediate: true
    }

  },


  computed: {

    typeTVA() {
      if (this.operationLot.typeLot && this.operationLot.typeLot.value && this.typesLot.length) {
        const match = this.typesLot.find(typeLot => typeLot.value === this.operationLot.typeLot.value)
        if (match) {
          return this.$i18n.t(match.typeTVA) + " " + this.$i18n.t('and') + ' ' + this.$i18n.t(match.recuperable)
        }
      }
      return ''
    }

  },

  emits: ['removedOperationLot', 'didChangeValue'],

  methods: {

    scheduleChanged(schedule) {
      this.operationLot.schedule.value = schedule
      this.emitChangeValue(this.operationLot)
    },

    handleSSPVenteChange() {
      if (!this.operationLot.realDateSSP.value) {
        this.operationLot.realDate.value = false;
      }
      this.emitChangeValue(this.operationLot)
    },

    handleIsLoueChange() {
      if (!this.operationLot.isLoue.value) {
        this.operationLot.dateFinBail.value = null;
        this.operationLot.loyersPercus.value = null;
        this.operationLot.tauxTVA.value = null;
        this.operationLot.nomLocataire.value = null;
        this.operationLot.dateButoirResiliation.value = null;
      }
      this.emitChangeValue(this.operationLot);
    },

    isActeVenteDisabled() {
      this.emitChangeValue(this.operationLot)
      return !this.operationLot.realDateSSP.value;
    },

    removeOperationLot() {
      this.$emit('removedOperationLot', this.operationLot)
    },

    removeInvalidFeedback(field) {
      this.operationLot[field]['state'] = null
      this.operationLot[field]['invalidFeedback'] = null
    },

    async emitChangeValue(operationLot) {
      console.log("emitChangeValue")
      this.$emit('didChangeValue', operationLot)
    },


    updateValues(modified) {
      switch (modified) {
        case 'surface' :
          if (this.operationLot.prixParM2) {
            this.operationLot.prixVenteTTC.value = Number(this.operationLot.surface.value * this.operationLot.prixParM2.value).toFixed(2)
          } else if (this.simulationLot.prixVenteTTC.value) {
            this.operationLot.prixParM2.value = Number(this.operationLot.prixVenteTTC.value / this.operationLot.surface.value).toFixed(2)
          } else {
            this.operationLot.prixVenteTTC.value = 0
          }
          break;
        case 'prixParM2' :
          if (this.operationLot.surface.value) {
            this.operationLot.prixVenteTTC.value = Number(this.operationLot.surface.value * this.operationLot.prixParM2.value).toFixed(2)
          } else {
            this.operationLot.prixVenteTTC.value = 0
          }
          break;
        case 'prixVenteTTC':
          if (this.operationLot.surface.value) {
            this.operationLot.prixParM2.value = Number(this.operationLot.prixVenteTTC.value / this.operationLot.surface.value).toFixed(2)
          } else {
            this.operationLot.prixParM2.value = 0
          }
          break;
        default:
          break;
      }
    }

  }

}

</script>

<style scoped>

#typeTVA {
  padding: 8px 12px;
  border-radius: 4px;
  background-color: #EAEDF4;
}

.disabled-field {
  opacity: 0.6;
  pointer-events: none;
}

.disabled-field .form-control {
  background-color: #e9ecef;
}

</style>



// WEBPACK FOOTER //
// src/views/operation/components/OperationLotComponent.vue